import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import { StyledFestivalPrice } from '../components/styled-festival-price';
import { formatCurrency } from '../helpers/formatCurrency';
// import { breakpoints } from '../helpers/breakpoints';

const StyledPropertyCard = styled.article`
  display: block;
  width: 100%;
  background: var(--c-white);
  border-radius: 2.5rem;
  max-width: ${props => (props.maxWidth ? props.maxWidth : `none`)};
  transition: all 0.3s ease;
  box-shadow: var(--shadow);
  @media (hover: hover) {
    &:hover {
      transform: translateY(-0.5rem);
    }
  }
`;

const StyledPropertyCardLink = styled(Link)`
  color: var(--c-black);
  text-decoration: none;
`;

const StyledPropertyCardImage = styled.div`
  border-radius: 2.5rem 2.5rem 0 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
  max-height: 16rem;
  background: var(--c-red);
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

const StyledPropertyCardContent = styled.div`
  padding: 2.5rem;
  background: var(--c-white);
  border-radius: 0 0 2.5rem 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  span,
  b {
    font-weight: 800;
  }
  span {
    color: var(--c-red);
    font-size: 1.2rem;
  }
`;

const StyledPropertyCardTitle = styled.h3`
  margin: 0 0 1rem;
`;

const PropertyCard = props => {
  const { title, imageSrc, linkTo, price, sleeps, bookingIncentive, maxWidth, style } = props;

  return (
    <StyledPropertyCard maxWidth={maxWidth} style={style}>
      <StyledPropertyCardLink to={linkTo}>
        <StyledPropertyCardImage>
          <Img
            fluid={imageSrc}
            alt={`Interior shot of ${title}`}
            style={{
              height: '100%',
            }}
          />
        </StyledPropertyCardImage>
        <StyledPropertyCardContent>
          <StyledPropertyCardTitle>{title}</StyledPropertyCardTitle>
          <p>
            From: <StyledFestivalPrice>{formatCurrency.format(price)}</StyledFestivalPrice> per night
            <br />
            Sleeps: <b>{sleeps[0] === sleeps[sleeps.length - 1] ? sleeps[0] : `${sleeps[0]} - ${sleeps[sleeps.length - 1]}`}</b>
          </p>
          {bookingIncentive ? <span>{bookingIncentive}</span> : null}
        </StyledPropertyCardContent>
      </StyledPropertyCardLink>
    </StyledPropertyCard>
  );
};

PropertyCard.propTypes = {
  title: PropTypes.string,
  image: PropTypes.string,
  price: PropTypes.number,
  sleeps: PropTypes.array,
  linkTo: PropTypes.string,
};

export default PropertyCard;
